export const environment = {
  production: false,
  KEYCLOAK_URL: 'https://acessopoa-hom.procempa.com.br/auth',
  KEYCLOAK_REALM: 'acessopoa',
  KEYCLOAK_CLIENT: 'etpelevadores',
  apiUrl: "https://elevadores-hom.procempa.com.br/etpelevadores/rest/secure/empresas",
};
